/**
 * @Author: shenyi
 * @Date:   2023-08-13 16:59:24
 * @Last Modified by:   shenyi
 * @Last Modified time: 2023-09-26 20:05:36
 */
import axios from "axios";

const getUrl = async () => {
  if (!window.baseURL) {
    const { data: config } = await axios.request({
      url: `${
        window.location.origin
      }/fe-config.json?version=${new Date().getTime()}`,
      method: "get"
    });
    window.baseURL = `https://${config.apiHost}`;
    return "";
  }
};

export default getUrl;
